<!--
 * @Descripttion: 支付信息确认
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="pay-info-confirm">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    >
      <template #tableAfter>
        <div style="margin-top: 10px">
          <BaseDescriptions v-if="taxType === 1" :border="true" :column="4">
            <BaseDescriptionsItem label="已选中订单数量">
              {{ tipsInfoData.selectedNumber }}个
            </BaseDescriptionsItem>
            <BaseDescriptionsItem label="订单支付金额">
              {{ formatter.fen2yuan(tipsInfoData.orderPaymentAmount, '元') }}
            </BaseDescriptionsItem>
            <BaseDescriptionsItem label="账户可用余额">
              {{
                formatter.fen2yuan(tipsInfoData.accountAvailableBalance, '元')
              }}
            </BaseDescriptionsItem>
          </BaseDescriptions>
          <BaseDescriptions
            v-else-if="taxType === 2"
            :border="true"
            :column="4"
          >
            <BaseDescriptionsItem label="已选中订单数量">
              {{ tipsInfoData.selectedNumber }}个
            </BaseDescriptionsItem>
            <BaseDescriptionsItem label="预计扣除个税金额">
              {{
                formatter.fen2yuan(tipsInfoData.deductIndividualTaxAmount, '元')
              }}
            </BaseDescriptionsItem>
            <BaseDescriptionsItem label="预计订单支付金额">
              {{ formatter.fen2yuan(tipsInfoData.paidOrderAmount, '元') }}
            </BaseDescriptionsItem>
            <BaseDescriptionsItem label="账户可用余额">
              {{
                formatter.fen2yuan(tipsInfoData.accountAvailableBalance, '元')
              }}
            </BaseDescriptionsItem>
          </BaseDescriptions>
        </div>
      </template>
    </xrk-table>

    <div style="padding-bottom: 0; padding-right: 0" class="xrk-dialog__footer">
      <BaseButton type="default" @click="props.done">取消</BaseButton>
      <BaseButton
        :disabled="
          !payInfo.length ||
          (isLine &&
            +tipsInfoData.accountAvailableBalance <
              +tipsInfoData.orderPaymentAmount)
        "
        type="primary"
        @click="onNext"
      >
        下一步
      </BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref, withDefaults, defineProps, computed } from 'vue';

import {
  BaseButton,
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  createDialog,
  BaseDescriptions,
  BaseDescriptionsItem
} from 'xrk-components';
import { formatter } from '@/utils';

import { confirmPageList } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  projectNameCol,
  orderTimeCol,
  orderTypeCol,
  payTypeCol,
  payPassagewayCol,
  orderPriceCol,
  yjkcPriceCol,
  yjzfPriceCol
} from '../fields/columns';
import { orderNoSearch, projectNameSearch } from '../fields/searchs';
import PayInfoConfirmNext from './pay-info-confirm-next.vue';
const props = withDefaults(
  defineProps<{
    done: any;
    payInfo: any[];
    taxType: number;
  }>(),
  {
    done: () => ({}),
    payInfo: null
  }
);
const taxType = computed(() => {
  return props.taxType as number;
});
const tipsInfoData = ref({
  selectedNumber: 0, //已选中订单笔数
  orderPaymentAmount: 0, //订单支付金额（分）
  accountAvailableBalance: 0, //账户可用余额（分）
  deductIndividualTaxAmount: 0, //预计扣除个税金额(分)-劳务（分）
  paidOrderAmount: 0 //  /** 预计实付订单金额-劳务（分） **/
});
const onNext = () => {
  createDialog({
    title: '支付信息确认',
    showFooter: false,
    contentRender: done => {
      return (
        <div style="padding: 20px">
          <PayInfoConfirmNext done={done} payInfo={props.payInfo} />
        </div>
      );
    }
  });
  props.done();
};

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [orderNoSearch, projectNameSearch],
  otherComponents: []
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      indexCol,
      orderNoCol,
      projectNameCol,
      orderTimeCol,
      payPassagewayCol,
      payTypeCol,
      orderTypeCol,
      orderPriceCol,
      taxType.value === 2 && yjkcPriceCol,
      taxType.value === 2 && yjzfPriceCol
    ].filter(Boolean)
  };
});

const isLine = props.payInfo.some(item => item.payType === 1);

const getListAjax = async params => {
  const reqData = {
    ...params,
    aspOrderIdList: props.payInfo.map(item => item.aspOrderId)
  };
  const data = await confirmPageList(reqData);
  tipsInfoData.value = data.data.remark;
  return data;
};
</script>
<style lang="scss"></style>
